/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TripDriver,
    TripDriverFromJSON,
    TripDriverFromJSONTyped,
    TripDriverToJSON,
} from './';

/**
 * 
 * @export
 * @interface TripEdit
 */
export interface TripEdit {
    /**
     * 
     * @type {boolean}
     * @memberof TripEdit
     */
    isPrivate?: boolean;
    /**
     * 
     * @type {TripDriver}
     * @memberof TripEdit
     */
    driver1?: TripDriver;
    /**
     * 
     * @type {number}
     * @memberof TripEdit
     */
    gpsKilometers?: number;
}

export function TripEditFromJSON(json: any): TripEdit {
    return TripEditFromJSONTyped(json, false);
}

export function TripEditFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripEdit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isPrivate': !exists(json, 'isPrivate') ? undefined : json['isPrivate'],
        'driver1': !exists(json, 'driver1') ? undefined : TripDriverFromJSON(json['driver1']),
        'gpsKilometers': !exists(json, 'gps_kilometers') ? undefined : json['gps_kilometers'],
    };
}

export function TripEditToJSON(value?: TripEdit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isPrivate': value.isPrivate,
        'driver1': TripDriverToJSON(value.driver1),
        'gps_kilometers': value.gpsKilometers,
    };
}


